import { cn } from '@/lib/utils';

export const POWER_BUY_NOW_URL = 'https://xat.com/powers';
export const POWER_TRADE_URL = 'https://xat.com/Trade';
export const POWER_TRADE_ICON_SRC = '/icons/trade.svg';
export const POWER_FAIRTRADE_ICON_SRC = '/icons/fairtrade.svg';

const powerCtaBaseClass = cn(
  'group relative inline-flex shrink-0 items-center justify-center gap-1.5 overflow-hidden rounded-full',
  'px-4 py-1.5 font-poppins text-xs font-bold uppercase tracking-wider',
  'text-white transition-[filter,box-shadow,transform] duration-200',
  'hover:brightness-110 active:scale-[0.98]',
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-[#030023]'
);

/** CTA «Comprar agora» — cyan/azul, alinhado ao tema Powers (não Aces). */
export const powerBuyNowButtonClass = cn(
  powerCtaBaseClass,
  'focus-visible:ring-sky-400/70'
);

export const POWER_BUY_NOW_BUTTON_STYLE = {
  background: 'linear-gradient(90deg, #0284c7 0%, #0ea5e9 45%, #38bdf8 100%)',
  boxShadow:
    '0 0 0 1px rgba(56,189,248,0.45), 0 4px 14px rgba(14,165,233,0.28), inset 0 1px 0 rgba(255,255,255,0.22)',
} as const;

/** CTA «Comprar no Trade» — violeta, distinto do badge laranja e dos Aces. */
export const powerTradeButtonClass = cn(
  powerCtaBaseClass,
  'focus-visible:ring-violet-400/70'
);

export const POWER_TRADE_BUTTON_STYLE = {
  background: 'linear-gradient(90deg, #6d28d9 0%, #7c3aed 50%, #8b5cf6 100%)',
  boxShadow:
    '0 0 0 1px rgba(167,139,250,0.4), 0 4px 14px rgba(124,58,237,0.32), inset 0 1px 0 rgba(255,255,255,0.18)',
} as const;

/** Separador vertical entre badges e CTA na mesma linha. */
export const powerCtaSeparatorClass = cn(
  'mx-2 h-7 w-px shrink-0 bg-gradient-to-b from-transparent via-white/25 to-transparent'
);
